<template>
  <div class="divide-y divide-slate-100">
    <div
      v-for="(item, idx) in items"
      :key="`${item.label}-${idx}`"
      class="flex items-start justify-between gap-4 px-4 py-2.5 text-sm"
    >
      <div class="min-w-0">
        <p class="text-slate-700">{{ item.label }}</p>
        <p v-if="item.detail" class="text-xs text-slate-500">{{ item.detail }}</p>
        <p v-if="showFormula(item)" class="text-xs text-slate-400 mt-0.5">
          {{ formatNumber(item.quantity) }} {{ item.unit }} ×
          <span v-currency="item.unitPrice">{{ item.unitPrice }}</span>
        </p>
      </div>
      <div class="text-right shrink-0 font-medium text-slate-700">
        <span v-if="item.cost === 0" class="text-emerald-600">Free</span>
        <span v-else v-currency="item.cost" :key="item.cost">{{ item.cost }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { round } from "@/utils/pricing";

export default {
  name: "LineItems",
  props: {
    items: { type: Array, default: () => [] },
  },
  methods: {
    showFormula(item) {
      return Boolean(item.unit) && item.unitPrice > 0;
    },
    formatNumber(value) {
      return round(Number(value) || 0, 4).toLocaleString();
    },
  },
};
</script>
